import React from 'react'
import { ToggleButtonGroup } from '../../ToggleButtonGroup'
import { ToggleButton } from '../../ToggleButton'

interface OptionProps extends React.ComponentProps<typeof ToggleButton> {
  label?: React.ReactNode
}
interface Props extends React.ComponentProps<typeof ToggleButtonGroup> {
  options: OptionProps[]
}

export const ToggleButtonGroupWrapper = ({ options, ...props }: Props) => {
  return (
    <ToggleButtonGroup {...props}>
      {options.map(option => (
        <ToggleButton value={option.value}>{option.label}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
